import { Dispatch, SetStateAction } from 'react';

import { HeaderEnd } from './header-end';
import { HeaderStart } from './header-start';

type HeaderProps = {
    isCollapsed: boolean;
    setIsCollapsed: Dispatch<SetStateAction<boolean>>;
};

export const Header = ({ isCollapsed, setIsCollapsed }: HeaderProps) => {
    return (
        <header className="sticky top-0 z-50 min-h-[var(--header-height)] border-b bg-white px-2">
            <div className="flex h-full items-center justify-between">
                <HeaderStart
                    isCollapsed={isCollapsed}
                    setIsCollapsed={setIsCollapsed}
                />
                <HeaderEnd />
            </div>
        </header>
    );
};

// className="border-box sticky bottom-0 top-0 z-50 flex h-[var(--header-height)] items-center justify-between border-b-[1px] bg-white px-5"
